// extracted by mini-css-extract-plugin
export default {"toggleButton":"styles_toggleButton__GeoYn","collapsed":"styles_collapsed__CGjWl","expanded":"styles_expanded__cdwYy"};